import React from 'react';

// Common status mappings
export const STATUS_MAPPING = {
  DRAFT: 'draft',
  COMPILED: 'compiled',
  ON_SALE: 'onSale',
  CLAIMED: 'claimed',
  SAMPLE_COLLECTION_IN_PROGRESS: 'sampleCollectionInProgress',
  PREPARING_FOR_SHIPPING_TO_LAB: 'preparingForShippingToLab',
  SUCCESSFULLY_PROCESSED_BY_LAB: 'successfullyProcessedByLab',
  COMPLETED: 'completed',
} as const;

// Common empty table message component
export const EmptyTableMessage: React.FC<{
  searchQuery?: string;
  selectedFilter?: string | null;
}> = ({ searchQuery, selectedFilter }) => (
  <div className="no-results-content">
    <span className="no-results-icon">&#128237;</span>
    <h4>No patient test results found</h4>
    {(searchQuery || selectedFilter) && (
      <p>Try adjusting your search or filter criteria</p>
    )}
  </div>
);

// Common loading component
export const LoadingSpinner: React.FC<{ message?: string }> = ({
  message = 'Loading patient data...',
}) => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
    <p>{message}</p>
  </div>
);

// Common handleKeyDown for search
export const createSearchKeyHandler = (onSearch: () => void) => {
  return (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };
};

